import { requesterS3 } from '@/lib/axios';
import { IMAGE_TIMEOUT } from '../../constants';

export async function getFile(url: string) {
  return await requesterS3({
    responseType: 'blob',
  }).get(url);
}

export async function getFileHead(url: string, timeout = IMAGE_TIMEOUT) {
  return await requesterS3().head(url, { timeout });
}
